import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { CachedImage } from '@usepepper/ui/atoms/cached-image';
import { DisplayAdDetailComponent } from './display-ad-detail-component';
import { PageContainer } from '@/components/page-container';
import { StackScreenProps } from '@react-navigation/stack';
import { StyleSheet } from 'react-native';

type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.DisplayAd
>;

export const DisplayAdDetailScreen: React.FC<Props> = ({ route }) => {
  const { displayAd, listData } = route.params;
  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        title: displayAd.content.logo_image_url ? (
          <CachedImage
            alt="" // TODO: make this configurable by advertiser, currently don't have meaningful default alt text
            contentFit="contain"
            source={{ uri: displayAd.content.logo_image_url }}
            style={styles.logo}
          />
        ) : (
          (displayAd.content.title ?? '')
        ),
      }}
    >
      <DisplayAdDetailComponent displayAd={displayAd} listData={listData} />
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  logo: {
    aspectRatio: 1,
    height: 48,
  },
});
